import { useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useAuthStore } from '../store/authStore'
import mccLogo from '@/assets/mcc_logo.png'
import { Container } from '@/components/Container'
import { LoginForm } from '@/features/auth/components/LoginForm'
import { ForgotPassword } from '@/features/auth/pages/ForgotPassword'

function Login() {
  const navigate = useNavigate()
  const { isAuthenticated, user } = useAuthStore()

  useEffect(() => {
    if (isAuthenticated && user) {
      const to = user.roles.length > 1 ? '/select-role' : '/'
      navigate({ to })
    }
  }, [isAuthenticated, user, navigate])

  return (
    <Container>
      <div className="flex flex-col items-center gap-6">
        <img
          src={mccLogo}
          alt="Maranatha Christian Church"
          className="w-48 sm:w-52"
        />
        <div className="w-full max-w-sm rounded-lg border bg-white p-6 shadow-sm">
          <h1 className="mb-4 text-xl font-semibold">Login</h1>
          <LoginForm />
          <ForgotPassword />
        </div>
      </div>
    </Container>
  )
}

export default Login
